import { combineReducers } from '@reduxjs/toolkit';
import reduxMasterReducer from './reduxMasterSlice';

const rootReducer = combineReducers({
    reduxMaster: reduxMasterReducer,
});

export default rootReducer;
